__turbopack_context__.v({
  "Version": "layout-header-module__TQJCDa__Version",
  "mainHeader": "layout-header-module__TQJCDa__mainHeader",
  "mainHeaderContent": "layout-header-module__TQJCDa__mainHeaderContent",
  "userInfo": "layout-header-module__TQJCDa__userInfo",
});
